<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
    status: string;
}>();

const badgeConfig = computed(() => {
    switch (props.status) {
        case 'completed':
        case 'done':
        case 'clear':
            return { label: 'Completed', theme: 'done' };
        case 'in_progress':
        case 'active':
            return { label: 'In progress', theme: 'progress' };
        case 'failed':
        case 'fail':
        case 'cancelled':
        case 'denied':
            return { label: 'Failed', theme: 'fail' };
        case 'pending':
        case 'new_order':
            return { label: 'New', theme: 'new' };
        default: // unknown → "New"
            return { label: 'New', theme: 'new' };
    }
});
</script>

<template>
    <span class="status-badge" :class="`status-badge--${badgeConfig.theme}`">
        {{ badgeConfig.label }}
    </span>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.status-badge {
    font-size: $text-portal-small;
    font-weight: 700;
    padding: 2px 6px;
    border-radius: $portal-tag-radius;
    white-space: nowrap;
    flex-shrink: 0;

    &--new {
        background: #DEEFF9;
        color: #0b273e;
    }

    &--progress {
        background: #FFF4D0;
        color: #322705;
    }

    &--done {
        background: #CBF5DC;
        color: #0B351C;
    }

    &--fail {
        background: #F8D7DA;
        color: #721c24;
    }
}
</style>
